<template>
  <div
    class="wt-area-picker"
    :class="{
      active: activeOverlay === field.name,
      '-has-active-toggle': showActiveControl,
    }"
    @click="onAreaClick"
    @mouseenter="hoverOnArea"
    @mouseleave="leaveArea"
  >
    <span class="-label">{{ field.label }}</span>
    <slot name="tooltip" />

    <div
      v-if="showActiveControl"
      class="-active-toggle"
      :title="activeTitle"
      @click.stop
    >
      <wt-toggle :checked="isActive" @toggle="onActiveToggle" />
    </div>
  </div>
</template>

<script>
import fieldsMixin from '../mixins/fields.vue';
import { isFieldShown } from 'AssetEditor/functionality/CustomOverlays/objectTrackingApi';
import { mapMutations } from 'vuex';

export default {
  props: {
    field: {
      type: Object,
      required: true,
      validator(value) {
        return _.every(['name'], (prop) => _.includes(_.keys(value), prop));
      },
    },
  },

  mixins: [fieldsMixin],

  mounted() {
    this.fieldReadyNextTick();
  },

  computed: {
    activeOverlay() {
      return this.$store.state.assetEditor.pageTmpState.activeOverlay;
    },

    /**
     * AREA only. This component also renders POINT fields (registered as
     * FieldPoint), and the point picker has no hidden state - a toggle there
     * would write `active` to the story and change nothing on screen.
     */
    showActiveControl() {
      return (
        this.field.type === 'AREA' && this.field.showActiveControl === true
      );
    },

    isActive() {
      return isFieldShown(this.field);
    },

    activeTitle() {
      return this.isActive ? 'Hide this area' : 'Show this area';
    },
  },

  methods: {
    ...mapMutations('assetEditor', ['setTmpPageState']),

    onAreaClick() {
      if (!this.isActive) {
        return; // nothing to select - the area is hidden
      }
      this.setTmpPageState({ activeOverlay: this.field.name });
    },

    onActiveToggle(checked) {
      // `active` sits next to the field's value in the agd - not part of it
      this.$emit('change', {
        valueChanges: {
          name: this.field.name,
          type: this.field.type,
          active: checked,
        },
      });

      if (!checked && this.activeOverlay === this.field.name) {
        // do not leave a hidden area as the selected overlay
        this.setTmpPageState({ activeOverlay: null });
      }
    },

    hoverOnArea() {
      this.setTmpPageState({ hoveredField: this.field.name });
    },

    leaveArea() {
      this.setTmpPageState({ hoveredField: null });
    },
  },
};
</script>
